import React from 'react';
import { Address } from '@Types/account';
import { Country } from '@Types/config/Country';
import FormFieldInput from 'components/revelo-ui/forms/form-field-input';
import FormFieldSelect from '../../../forms/form-field-select';

export interface AddressFormProps {
  address?: Address;
  type: 'billing' | 'shipping';
  countries?: Country[];
}

const AddressForm: React.FC<AddressFormProps> = ({ address, type, countries = [] }) => {
  return (
    <>
      <div>
        <FormFieldInput
          name={`${type}.firstName`}
          inputType="text"
          inputAutoComplete={`${type} given-name`}
          value={address?.firstName || ''}
          containerClassNames=""
          label="Vorname"
          placeholder="Vorname"
          validation={{ required: true }}
        />
      </div>
      <div>
        <FormFieldInput
          name={`${type}.lastName`}
          inputType="text"
          inputAutoComplete={`${type} family-name`}
          value={address?.lastName || ''}
          containerClassNames=""
          label="Nachname"
          placeholder="Nachname"
          validation={{ required: true }}
        />
      </div>
      <div>
        <FormFieldInput
          name={`${type}.streetName`}
          inputType="text"
          inputAutoComplete={`${type} address-line1`}
          value={address?.streetName || ''}
          containerClassNames=""
          label="Straße"
          placeholder="Straße"
          validation={{ required: true }}
        />
      </div>
      <div>
        <FormFieldInput
          name={`${type}.streetNumber`}
          inputType="text"
          inputAutoComplete={`${type} address-line1`}
          value={address?.streetNumber || ''}
          containerClassNames=""
          label="Hausnummer"
          placeholder="Hausnummer"
          validation={{ required: true }}
        />
      </div>
      <div>
        <FormFieldInput
          name={`${type}.postalCode`}
          inputType="text"
          inputAutoComplete={`${type} postal-code`}
          value={address?.postalCode || ''}
          containerClassNames=""
          label="PLZ"
          placeholder="PLZ"
          validation={{ required: true }}
        />
      </div>
      <div>
        <FormFieldInput
          name={`${type}.city`}
          inputType="text"
          inputAutoComplete={`${type} address-level2`}
          value={address?.city || ''}
          containerClassNames=""
          label="Stadt"
          placeholder="Stadt"
          validation={{ required: true }}
        />
      </div>
      <div>
        <FormFieldSelect
          name={`${type}.country`}
          options={countries.map((country) => ({
            display: country.countryName,
            data: country.isoCode,
            disabled: false,
          }))}
          selectedOptionValue={
            countries.find((country) => country.isoCode === address?.country)?.isoCode ?? countries[0]?.isoCode ?? 'DE'
          }
          containerClassNames="col-span-full sm:col-span-12"
          validation={{
            required: true,
          }}
        />
      </div>
      <div>
        <FormFieldInput
          name={`${type}.additionalStreetInfo`}
          inputType="text"
          inputAutoComplete={`${type} address-line2`}
          value={address?.additionalStreetInfo || ''}
          containerClassNames=""
          label="Adresszusatz"
          placeholder="Adresszusatz (optional)"
        />
      </div>
      <div>
        <FormFieldInput
          name={`${type}.company`}
          inputType="text"
          inputAutoComplete={`${type} organization`}
          value={address?.company || ''}
          containerClassNames=""
          label="Firma"
          placeholder="Firma (optional)"
        />
      </div>
    </>
  );
};

export default AddressForm;
